module.exports = function (moveFocus, breakpointsService) {
    return {
        restrict: 'E',
        scope: {
            categories: '=',
            currentCategory: '@',
            landingOptions: '=',
            stateOptions: '='
        },
        link(scope) {

            scope.breakpoints = breakpointsService;

            scope.toggleCategory = function (category) {
                const isExpanded = scope.currentCategory === category;
                scope.currentCategory = isExpanded ? {} : category;

                if (!isExpanded) {
                    moveFocus('._expandedCategoryItems li:first-child a');
                }
            };

            scope.getUrl = function (category, childCategory) {
                return scope.stateOptions.state + '({ ' + scope.stateOptions.category + ': "' + category.UrlFriendlyName + '", ' + scope.stateOptions.subCategory + ': "' + childCategory.UrlFriendlyName + '", name: undefined, productId: undefined, recipeId: undefined, cardId: undefined, pageNumber: undefined})';
            };

            scope.$on('categories:change', function (event, args) {
                scope.currentCategory = args.currentCategory.department;
            });
        },
        template: require('./categories-navigation-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/categories/categories-navigation-directive.js
 **/